import { InView } from 'react-intersection-observer'
import { TraitTypes } from './types'
import Graph from './Widgets/Graph'
import Text from './Widgets/Text'
import Button from './Widgets/Button'
import ActionButton from './Widgets/ActionButton'

export const getTraitComponent = (data: {
  title?: string | number
  trait?: TraitTypes['trait']
  textColor?: string
  image_url?: string
  style?: string
  className?: string
  url?: string
  onClick?: () => void
  tooltipTitle?: string
}) => {
  switch (data.trait) {
    case 'text':
      return <Text data={data} />

    case 'button':
      return <Button data={data} />

    case 'graph':
      return (
        <InView triggerOnce>
          {({ inView, ref }) => (
            <div ref={ref}>{inView ? <Graph data={data} /> : ''}</div>
          )}
        </InView>
      )

    case 'actionButton':
      return <ActionButton data={data} />

    default:
      return <div>Here</div>
  }
}
